var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcSend24X24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m3.254 6.2 2.48 5.8-2.48 5.8c-.43 1 .58 2.03 1.59 1.61l15.24-6.28c1.01-.41 1.01-1.84 0-2.26L4.844 4.6c-1.01-.42-2.02.6-1.59 1.6Z",
  fill: "#A4AEBA"
})));
export default SvgIcSend24X24;